import React, {useState} from "react";
import {observer} from "mobx-react";
import DraggableInput from '../Shared/DraggableInput';
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";
import {DATA_INTERVAL} from "../../MobxStores/DataStore";

const EditMediaProcedureDialog = observer(() => {
    const {modalStore, generalStore, projectStore, procedureStore, dataStore} = useStores();
    const [dragging, setDragging] = useState(false);
    const [file, setFile] = useState(null);


    function closeModal() {
        modalStore.resetModalData();
        modalStore.isEditMediaProcedureDialogOpen = false;
    }

    function saveFileInState(files) {
        setFile(files[0]);
    }

    async function replaceProcedureMedia() {
        generalStore.isLoaderOpen = true;

        try {
            if (file.size === 0) {
                throw new Error('empty file'); // folder probably
            }
            const [fileData] = await generalStore.uploadFiles([file]);
            const savedProcedure = await procedureStore.replaceProcedureMedia(fileData);
            const projectId = projectStore.currentProject?.ProjectIdentifier;

            const projectProceduresMap = dataStore.projectsProceduresMap.get(projectId) || new Map();
            projectProceduresMap.set(savedProcedure.ProcedureIdentifier, savedProcedure);
            dataStore.set('projectsProceduresMap', projectId, projectProceduresMap);
            dataStore.set('projectsProceduresExpirationMap', projectId, Date.now() + DATA_INTERVAL);
            closeModal();
            generalStore.isLoaderOpen = false;
            await projectStore.refreshProjectDetails();
        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('problemUploadingFile'));
            generalStore.isLoaderOpen = false;
        }
    }

    return (
        <GeneralDialog
            openControl='isEditMediaProcedureDialogOpen'
            className={'blue-dialog dialog big-dialog create-media-procedure-dialog' + (dragging ? ' dragging' : '')}
            title={generalStore.translate('replaceMediaProcedure')}
            body={
                <div>
                    <div>
                        {generalStore.translate('selectAMediaFileToReplace')}
                    </div>
                    <div className='dragging-container'>
                        {modalStore.isEditMediaProcedureDialogOpen ? (
                            <DraggableInput
                                onInputSelected={saveFileInState}
                                onDragStart={() => setDragging(true)}
                                onDragStop={() => setDragging(false)}
                            />
                        ) : null}
                    </div>
                    {file ? <div>{generalStore.translate('fileSelected')} {file.name}</div> : null}
                </div>
            }
            isConfirmDisabled={!file}
            onConfirm={replaceProcedureMedia}
            confirmText={generalStore.translate('replace')}
        />
    );
});

export default EditMediaProcedureDialog;
